var errorsArr = [];
// fix label if input not empty
function labelFix() {
    $('.form-control').each(function () {
        $(this).on('keyup click change focus', function () {
            var val = $(this).val();
            if (val != null && val.length > 0 || $(this).hasClass('error')) {
                $(this).parent().find('label').addClass('not-empty');
            } else {
                $(this).parent().find('label').removeClass('not-empty');
            }
        });
    });
}

labelFix();
$(document).ready(function () {    
    // Add new Reward
    var optionsRewards = {
        beforeSubmit: function (arr, $form, options) {
            return true;
        },
        success: function (arr, $form, options) {
        },
        resetForm: true        // reset the form after successful submit
    };

    $('.show-popup').on('click', function (e) {
        var popup = $(this).data('popup');
        if (popup !== 'promote') {
            Auth.hasIdentity(function (status, resp) {
                if (status === false) {
                    e.preventDefault();
                    Auth.showLoginForm(null, null, null, $('#join-window'));
                    return false;
                } else {
                    $('#' + popup).show();
                }
            });
        } else {
            $('#' + popup).show();
        }
//        $('html, body').css('overflow','hidden');
    });

    $('.copy').on('click', function () {
        $(this).parent().find('.copied').show().delay(1000).fadeOut(1000);
        var inputForCopy = $(this).parents('.form-group').find('input');
        var temp = $('<input>');

        $('body').append(temp);
        temp.val(inputForCopy.val()).select();
        document.execCommand('copy');
        temp.remove();
    });

    $('.countdown').each(function () {
        var dates = $(this).attr('data-date');
        // var lastDate = new Date(dates+':00Z');
        var lastDate = new Date(dates);
        lastDate = new Date(Date.UTC(lastDate.getFullYear(), lastDate.getMonth(), lastDate.getDate(), lastDate.getHours(), lastDate.getMinutes(), 0));

        $(this).countdown({
            until: lastDate,
            onExpiry: liftOff,
            format: 'DHMS',
            labels: ['years', 'months', 'weeks', 'days', 'hours', 'min', 'sec'],
            layout: '<ul>{d<}<li><span>{dl}</span><p>{dn}</p></li>{d>}{h<}<li><span>{hl}</span><p>{hn}</p></li>{h>}' +
                    '{m<}<li><span>{ml}</span><p>{mn}</p></li>{m>}{s<}<li><span>{sl}</span><p>{sn}</p></li>{s>}</ul>'
        });
    });

    function liftOff() {
        $('.countdown-block').addClass('finished').addClass('finish-success');
        $('.what-wrapper').hide();
        $('.countdown').hide();
        $('.class-for-hide-finished').css('display', 'none');
        $('.countdown-block').append('Finished!');
    }

    // fotoramaInit();
// Upload Author Images on Project Page
    var options = {
        beforeSubmit: beforeSubmit, // pre-submit callback
        success: afterSuccess, // post-submit callback
        uploadProgress: OnProgress, //upload progress callback
        resetForm: true        // reset the form after successful submit
    };
    // Avatar
    $('.upload-image-btn').change(function (e) {
        e.preventDefault();
        this.form.action = window.Config.BASE_PATH + '/api/v1/project/upload-image';
        $(this.form).ajaxSubmit(options);
        return false;
    });
    
    function getRoundedCanvas(sourceCanvas) {
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            var width = sourceCanvas.width;
            var height = sourceCanvas.height;

            canvas.width = width;
            canvas.height = height;

            context.imageSmoothingEnabled = true;
            context.drawImage(sourceCanvas, 0, 0, width, height);
            context.globalCompositeOperation = 'destination-in';
            context.beginPath();
            context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
            context.fill();

            return canvas;
        }

        var image = document.getElementById('image');
        var button = document.getElementById('button');
//        var result = document.getElementById('result');
        var croppable = false;

        var x;
        var y;
        var w;
        var h;
        var cropper;

    function afterSuccess(resp) {
        $('body').removeClass('loading');
        if (resp.success) {
            var imgSrc = resp.data.fileName + '?' + Math.random(9999999);
            if (resp.data.type == 'avatar') {
                $('.author-photo .avatar-image').attr('src', imgSrc);
                $('.book-info .avatar-image').attr('src', imgSrc);
                $('.small-avatar').attr('src', imgSrc);
                $('.about-authors .delete').removeClass('inactive');
            } else if (resp.data.type == 'cover') {

            }
            $('#cropping').show();

                document.getElementById('image').setAttribute("src", imgSrc);

                cropper = new Cropper(image, {
                    checkOrientation: false,
                    aspectRatio: 1,
                    viewMode: 1,
                    ready: function () {
                        croppable = true;
                    },
                    crop: function (e) {
                        x = e.detail.x;
                        y = e.detail.y;
                        w = e.detail.width;
                        h = e.detail.height;
                    }
                });

                button.onclick = function () {
                    button.classList.add("clickable");
                    var croppedCanvas;
                    var roundedCanvas;
                    var roundedImage;

                    var data = {
                        x: x,
                        y: y,
                        h: h,
                        w: w,
                        type: 'avatar_project',
                        pid: $('#pid').val()
                    }

                    $.ajax({
                        url: window.Config.BASE_PATH + '/api/v1/auth/crop-image',
                        type: 'post',
                        dataType: 'json',
                        data: data,
                        success: function (resp) {
                            if (resp.success) {
                                
                                //load cropped avatar for IE
                                if('objectFit' in document.documentElement.style === false) {
//                                    $('.author-photo .avatar-image').parent().css('background-image', 'url('+resp.data.filename+')');
//                                    $('.book-info .avatar-image').parent().css('background-image', 'url('+resp.data.filename+')');
                                }     
                                
                                $('.author-photo .avatar-image').attr('src', resp.data.filename);
                                $('.book-info .avatar-image').attr('src', resp.data.filename);
                                cropper.destroy();
                                $('#cropping').hide();
                            } else {
                                System.error(resp.message);
                                cropper.destroy();
                                $('#cropping').hide();
                            }
                        }
                    })

                    if (!croppable) {
                        return;
                    }

                    // Crop
                    croppedCanvas = cropper.getCroppedCanvas();

                    // Round
                    roundedCanvas = getRoundedCanvas(croppedCanvas);

                    // Show
                    roundedImage = document.createElement('img');
                    roundedImage.src = roundedCanvas.toDataURL();
//                        result.innerHTML = '';
//                        result.appendChild(roundedImage);


                };
        } else {
            System.showErrors(resp.message);
        }

        setTimeout(function () {
            $('.upload-image-container .close-btn').trigger('click');
        }, 1000)
        $('#submit-btn').show(); //hide submit button
        $('#loading-img').hide(); //hide submit button
        $('#progressbox').delay(1000).fadeOut(); //hide progress bar
    }

    //function to check file size before uploading.
    function beforeSubmit() {

        //check whether browser fully supports all File API
        if (window.File && window.FileReader && window.FileList && window.Blob) {
            //check empty input filed
            if (!$('#FileInput').val()) {
                System.error("No file selected");
                return false
            }

            var fsize = $('#FileInput')[0].files[0].size; //get file size
            var ftype = $('#FileInput')[0].files[0].type; // get file type

            //allow file types
            switch (ftype) {
                case 'image/png':
                //case 'image/gif':
                case 'image/jpeg':
                    //case 'image/pjpeg':
                    break;
                default:
                    System.error(locale['TEXT_IMG_WRONG_FORMAT']);
                    return false
            }

            // if File size > 5 MB - show proper error
            if (fsize > 5242880) {
                System.error("File must be 5 Mb or less.");
                return false;
            }

            $('body').addClass('loading');
        } else {
            //Output error to older unsupported browsers that doesn't support HTML5 File API
            $("#output").html(locale['TEXT_PLEASE_UPGRADE_YOUR_BROWSER']);
            return false;
        }
    }

    //progress bar function
    function OnProgress(event, position, total, percentComplete) {
        $('#progressbox').show();
        $('#progressbar').width(percentComplete + '%') //update progressbar percent complete
        $('#statustxt').html(percentComplete + '%'); //update status text
        if (percentComplete > 50) {
            $('#statustxt').css('color', '#000'); //change status text to white after 50%
        }
    }

    $('.delete-avatar-btn').on('click', function (e) {
        e.preventDefault();
        if ($('.about-authors .delete').hasClass('inactive')) {
            return;
        }
        $.ajax({
            url: window.Config.BASE_PATH + '/api/v1/project/delete-image',
            data: {'pid': $('#pid').val(), 'type': 'avatar'},
            type: 'post',
            dataType: 'json',
            success: function (resp) {
                if (resp.success) {
                    $('.author-photo .avatar-image').attr('src', resp.data.thumbName);
                    $('.book-info .avatar-image').attr('src', resp.data.thumbName);
                    $('.small-avatar').attr('src', resp.data.thumbName);
                    $('.about-authors .delete').addClass('inactive');
                    System.notify('Saved!');
                } else {
                    System.showErrors(resp.message);
                }
            }
        });
    })

///////////////////////////////////////////////////////////////////////

    $('.add-award').on('click', function () {
        $(this).parent().before('<div class="reward-block"><form method="POST" action=""><div class="reward"><div class="reward-variant form-group"><p class="claimed"><span>Pledge $</span> <input class="form-control" type="number" name="" min="0" step="1" value="0"></p></div><div class="award-title form-group"><input type="text" name="title" class="form-control" aria-invalid="false"><label>Title of the award</label></div><p><a href="#" class="exs">Examples</a></p><div class="form-group"><textarea class="form-control" name="message" rows="3"></textarea><label>Enter description</label></div><div class="form-group"><input class="form-control" type="number" name="" min="0" value=""><label>Set backer limit</label><button type="button" class="orange-btn thin-btn">ADD</button></div></div></form><p class="whose-award">Author Reward</p></div>');
    });

    $('.add-more').on('click', function () {
        $(this).parent().before(
                '<div class="load-gallery form-group">' +
                '<p>Image</p>' +
                '<ul>' +
                '<li class="for-load">Choose one image or several  to create a gallery<input class=" " name="" multiple id="imgGallery" type="file" /><label for="imgGallery"></label></li>' +
                '</ul>' +
                '</div>' +
                '<div class="form-group project-description">' +
                '<textarea class="form-control" name=""></textarea>' +
                '<label>Project description</label>' +
                '</div>');
    });

    // $(document).on('change', '.files', function(e){
    //     var files = e.target.files;
    //     var output = [];
    //
    //     for (var i = 0, f; f = files[i]; i++) {
    //         output.push('<li data-data="' + i + '">' + f.name + '<span class="remove-file"><svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg></span></li>');
    //     }
    //
    //     $(this).parent().next('.list').find('ul').append(output);
    // });
    //
    $(document).on('click', '.remove-file', function () {
        var data = $(this).parent().attr('data-data');

        var arr = $(this).parents('.list').prev().find('.files')[0].files;

        $(this).parent().remove();

        delete arr[data];
        $.ajax({
            data: {'pid': $('#pid').val()},
            type: 'post',
            dataType: 'json',
            url: window.Config.BASE_PATH + '/api/v1/auth/project-pdf-file-delete',
        })
                .done(function () {
                    authService.hasIdentity(null, true);
                    $('.pdfFiles.download a').attr('href', '');
                });
    });

    $(document).on('change', '#pdfFiles', function (e) {
        var file = $('#pdfFiles').val();
        if (file.match(/fakepath/)) {
            file = file.replace(/C:\\fakepath\\/i, '');
        }
        var list = $(this).parent().parent().find('.list ul')
        if (file.length == 0) {
            $(list).html('');
            $('#pdfFiles').val('');
            return false;
        }
        var re = /(?:\.([^.]+))?$/;
        var ext = re.exec(file)[1];
        if (ext != 'pdf') {
            file = '';
            $('#pdfFiles').addClass('error focus');
            System.showErrors('Wrong format: only .pdf files are supported.');
            $('#pdfFiles').val('');
            return false;
        }


        $('body').addClass('loading');
        var form = document.forms.projectPdfForm;
        var formData = new FormData(form);
        formData.append('pid', $('#pid').val());
        $.ajax({
            type: "POST",
            processData: false,
            contentType: false,
            url: window.Config.BASE_PATH + '/api/v1/auth/project-pdf-file-upload',
            data: formData,
        })
                .done(function (resp) {
                    authService.hasIdentity(null, true);
                    var url = $(list).parent().data('url') + resp.data.file;
                    $(list).html('<a target="_blank" href="' + url + '"><li data-data="file">' + file + '</a><span class="remove-file"><svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg></span></li>');
                    $('body').removeClass('loading');
                    $('.pdfFiles.download a').attr('href', url);
                    System.notify('The file has been uploaded successfully');
                });
        $('#pdfFiles').val('');
    });

//////////////////////////////////////////////////////////////////////////
    function nl2br(str) {
        return str.replace(/\n/g, '<br/>');
    }

    function readURL(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                $('.poster').attr('src', e.target.result);
            }

            reader.readAsDataURL(input.files[0]);
        }
    }

    $('.poster-load .delete a').on('click', function () {
        $(this).parents('.poster-block').find('.poster').attr('src', '/new_img/comming-soon_3х4.jpg');
    });

    // $('.save-update').on('click', function () {
    //     var title = $('.updates-title').val();
    //     var description = $('.updates-description').val();
    //     if (title == '') {
    //         $('.updates-title').addClass('error').focus();
    //         return false;
    //     }
    //     if (description.length > 0 && (description.length < 3 || description.length > 500)) {
    //         $('.updates-description').addClass('error').focus();
    //         return false;
    //     }
    //     var data = {'title': title, 'description': description};
    //     $.ajax({
    //         url: window.Config.BASE_PATH + '/api/v1/project/request-project-update-save',
    //         data: {'data': data, 'pid': $('#pid').val(), 'uid': $('#uid').val()},
    //         type: 'post',
    //         dataType: 'json',
    //         success: function (resp) {
    //             if (resp.success) {
    //                 $('.updates-title').val('');
    //                 $('.updates-description').val('');
    //                 $('.gallery-list').html('');
    //                 $('#uid').val('');
    //                 System.notify('Your project update has been sent for review. We will contact you by email as soon as the feedback is ready.');
    //             } else {
    //                 System.showErrors(resp.message);
    //             }
    //         }
    //     })
    //
    // });

    $('.cancel-edited').on('click', function () {
        var $el = $(this).closest('.edit-block');
        var $editor = $el.find('.edited-field');
        var $text = $el.find('.text-field');
        // var $editButton = $text.contents().filter(function(){  return this.nodeType !== 3 })
       var $editButton = $(this).closest('.edit-block').find('button.edit');
        var prevValue = $el.find('.origin-value').val();
        $editor.val(prevValue);
        var hasTags = $editor.attr('name') == 'description';

        if (hasTags) {
            $('.project-summernote').summernote('code', $('#description-origin-value').val());
            $text.html(prevValue)
                .append($editButton);
        } else {
            $text.html(nl2br(prevValue))
                .append($editButton);
        }
        $el.find('.edit-field').hide();
        $el.find('.text-field').show();

        if($el.hasClass('js-synopsis') && synopsisHeight > 132){

            $('.read-more-synopsis').removeClass('hidden');
        }
    });

    $('.filter-tab').on('click', function () {
        $('.filter-tab').removeClass('active');
        $(this).addClass('active');
        if ($(this).data('href') === 'all') {
            $('.tab-content').addClass('choosen');
        } else {
            $('.tab-content').removeClass('choosen');
            $('.' + $(this).data('href')).addClass('choosen');
        }
    });

    //initialize tooltipster on text input elements
    $('.authors-descr .form-control').tooltipster({
        trigger: 'custom',
        onlyOne: false,
        position: 'top-right',
        offsetX: 13
    });

//    $('textarea.form-control').each(function () {
//        $(this).on('change focus keyup', function (e) {
//            if (!$(this).hasClass('focus')) {
//                return false;
//            }
//            $(this).removeClass('error');
//            var required = $(this).data('required') == undefined ? false : true;
//            var minlength = $(this).data('minlength') == undefined ? 0 : Number($(this).data('minlength'));
//            var maxlength = $(this).data('maxlength') == undefined ? 0 : Number($(this).data('maxlength'));
//            var val = $.trim($(this).val());
//            if (val.length == 0 && required) {
//                $(this).addClass('error');
//                addTooltipler($(this), 'Sorry, field cannot be empty');
//                errors = true;
//            } else if ((minlength && val.length < minlength) || (maxlength && val.length > maxlength)) {
//                $(this).addClass('error');
//                addTooltipler($(this), 'Sorry, the text is too short (' + minlength + 'characters min and ' + maxlength + ' characters max)');
//                errors = true;
//            } else if (!required) {
//                destroyTooltipler(this);
//                $(this).removeClass('error').removeClass('success');
//            } else {
//                destroyTooltipler(this);
//                $(this).removeClass('error').addClass('success');
//            }
//        });
//    });

    function checkListEmails(emails) {
        var arr = emails.split(',');
        var res_arr = new Array();
        $.each(arr, function (index, value) {
            var email = value.trim();
            if (email != '' && !isValidEmailAddress(email)) {
                res_arr.push(email);
            }
        });
        return res_arr;
    }

    function countEmails(emails) {
        var arr = emails.split('@');
        return arr.length;
    }

    $(document).on('keyup', '#friends-emails', function () {
        var emails = $('#friends-emails').val();
        if (countEmails(emails) > 11) {
            $('#friends-emails').addClass('error');
            addTooltipler($('#friends-emails'), 'Too many emails.');
        } else {
            destroyTooltipler($('#friends-emails'));
            $('#friends-emails').removeClass('error');
        }
    });

    $(document).on('click', '#send-promote-to-friends', function (e) {
        e.preventDefault();
        var emails = $('#friends-emails').val();
        if(emails.length == 0) {
            $('#friends-emails').removeClass('success').addClass('error');
            return false;
        }
        var message = $('#friends-message').val();

        if (countEmails(emails) > 11) {
            $('#friends-emails').addClass('error');
            addTooltipler($('#friends-emails'), 'Too many emails.');
            show_alert('Too many emails.', 'error');
            return false;
        } else {
            destroyTooltipler($('#friends-emails'));
            $('#friends-emails').removeClass('error');
        }

        var not_correct_emails = checkListEmails(emails);
        if (not_correct_emails.length > 0) {
            show_alert('Invalid email format for ' + not_correct_emails.join(', '), 'error');
            return false;
        }
        if (!submitFriendsEmailsValidation()) {
            return false;
        }
        $('#send-promote-to-friends').attr('disabled', 'disabled');
        $.ajax({
            url: window.Config.BASE_PATH + '/api/v1/project/send-project-promote-to-friends',
            data: {'emails': emails, 'message': message, 'pid': $('#pid').val()},
            type: 'post',
            dataType: 'json',
            success: function (resp) {
                $('#send-promote-to-friends').removeAttr('disabled');
                if (resp.success) {
                    System.notify('Thank you! A message has been successfully sent to the specified email addresses.');
                    $('#friends-emails').removeClass('success');
                    $('#friends-message').removeClass('success');
                    $('#friends-emails').val('');
//                    $('#friends-message').val('');
                } else {
                    $('.main-form-submit').removeAttr('disabled');
                    System.showErrors(resp.message);
                }
            }
        });
        return false;
    });

    $('.main-form-submit').on('click', function (e) {
        e.preventDefault();
        var errors = false;
        var data = [];
        var button = $(this);
        var clearFields = $("#ia").val();
        // var l = Ladda.create($('button[type=submit]', this).get(0));
        var form = $(this).parent();
        var l = Ladda.create($('button[type=submit]', form).get(0));
        l.start();
        var openEdit = $('.edit-field:visible').length;
        if (openEdit > 0) {
            $("html, body").animate({scrollTop: $('.edit-field:visible:first').offset().top - 150}, "slow");
            System.error($('.edit-field:visible:first').data('text'));
            l.stop();
            return false;
        }

        $('.project-page .edited-field').each(function (index) {
            $(this).removeClass('error');

            var required = $(this).data('required') == undefined ? false : true;
            var minlength = $(this).data('minlength') == undefined ? 0 : Number($(this).data('minlength'));
            var maxlength = $(this).data('maxlength') == undefined ? 0 : Number($(this).data('maxlength'));
            var val = $.trim($(this).val());

            if (val.length == 0 && required) {
                $(this).addClass('error');
                addTooltipler($(this), locale['TEXT_FIELD_CANNOT_BE_EMPTY']);
                errors = true;
                System.showErrors(locale['TEXT_FIELD_CANNOT_BE_EMPTY']);
                $(this).closest('.edit-block').find('.edit').click();
            } else if ((minlength && val.length < minlength) || (maxlength && val.length > maxlength)) {
                $(this).addClass('error');
                System.showErrors(errorsArr[0]);
//                addTooltipler($(this), 'Sorry, the text is too short (' + minlength + 'characters min and ' + maxlength + ' characters max)');
                $(this).closest('.edit-block').find('.edit').click();
                errors = true;
            } else {
                destroyTooltipler($(this));
                $(this).removeClass('error').addClass('success');
            }
            data.push({
                'name': $(this).attr('name'),
                'value': val
            });
        });
        val = $('.project-summernote').summernote('code');
        var wohtml = $("<div />").html($('.project-summernote').summernote('code')).text();
        if (wohtml.length < 300) {
            System.showErrors('Please enter at least 300 characters at "Author’s pitch" field.');
            $('.note-editor').removeClass('success').addClass('error');
            addTooltipler($('.note-editor'), 'Please enter at least 300 characters');
            errors = true;
        } else if (wohtml.length > 100000) {
            $('.note-editor').removeClass('success').addClass('error');
            addTooltipler($('.note-editor'), 'Please enter no more than 100000 characters');
            errors = true;
        }
        if (errors) {
            l.stop();
            return false;
        }

        $(this).attr('disabled', 'disabled');
        $.ajax({
            url: window.Config.BASE_PATH + '/api/v1/project/request-project-data',
            data: {'data': data, 'pid': $('#pid').val()},
            type: 'post',
            dataType: 'json',
            success: function (resp) {
                if (resp.success) {
                    l.stop();
                    if (!clearFields) {
                        $('button.edit').remove();
                        $('.pdfFiles.add').remove();
                        if ($('.pdfFiles.download a').attr('href')) {
                            $('.pdfFiles.download').show();
                        }
                        $('.projectPdfForm .list').remove();

                        $('.edit-field').remove();
                        $('.submit-project-i').remove();
                        $('.poster-load-block').remove();
                        $('.photos_nav').remove();
                        $('.add-m-f form').remove();
                        $(button).parent().remove();
                        $('.main-form-submit').attr('disabled', 'disabled');
                    }
                    System.notify('Your project page has been submitted for review. We will contact you by email as soon as the feedback is ready.');
                } else {
                    $('.main-form-submit').removeAttr('disabled');
                    System.showErrors(resp.message);
                }
            }
        })
        return false;
    });

    $('.save-edited').on('click', function () {
        var $this = $(this);
        var $thisWrapper = $this.closest('.edit-block');
        var $editor = $thisWrapper.find('.edited-field');
        var $text = $thisWrapper.find('.text-field');
        var $editButton = $text.contents().filter('.edit');
        var val = $.trim($editor.val());
        var required = $editor.data('required') == undefined ? false : true;
        var hasTags = $editor.attr('name') == 'description';
        var synopsis = $editor.attr('name') == 'synopsis';
        var minlength = $editor.data('minlength') == undefined ? 0 : Number($editor.data('minlength'));
        var maxlength = $editor.data('maxlength') == undefined ? 0 : Number($editor.data('maxlength'));
        var editSynopsisHeight = '';
        $editor.removeClass('error');

        if (required && val.length == 0) {
            $editor.addClass('error');
            if(synopsis) {
                System.showErrors('Sorry, the Synopsis field cannot be empty');
            }
            return false;
        }

        if (minlength && val.length < minlength) {
            $editor.addClass('error');
            System.showErrors('Please enter at least '+minlength+' characters');
            return false;
        }

        if (maxlength && val.length > maxlength) {
            $editor.addClass('error');
            System.showErrors('Please enter no more than '+maxlength+' characters');
            return false;
        }
        var wohtml = '';
        if (hasTags) {
            val = $('.project-summernote').summernote('code');
            wohtml = $("<div />").html(val).text().trim();
            if (wohtml.length == 0) {
                System.showErrors('Sorry, the Author’s Pitch field cannot be empty');
                return false;
            } else if (wohtml.length < 300) {
                $('.note-editor').removeClass('success').addClass('error');
                addTooltipler($('.note-editor'), 'Please enter at least 300 characters');
                System.showErrors('Sorry, the text is too short (300 characters min)');
                return false;
            } else if (wohtml.length > 10000) {
                $('.note-editor').removeClass('success').addClass('error');
                addTooltipler($('.note-editor'), 'Please enter no more than 10000 characters');
                System.showErrors('Please enter no more than 10000 characters');
                return false;
            }
        }

        if (!$this.parents('#continue').hasClass('pay-info')) {
            $.ajax({
                url: window.Config.BASE_PATH + '/api/v1/project/update-project-data',
                data: {'name': $editor.attr('name'), 'value': val, 'pid': $('#pid').val()},
                type: 'post',
                dataType: 'json',
                success: function (resp) {
                    if (resp.success) {
                        System.notify('Saved!');
                    } else {
                        System.showErrors(resp.message);
                    }
                }
            })
        }

        if (hasTags) {
            $text.html(val).append($editButton);
        } else if ($this.parents('#continue').hasClass('pay-info')) {
            $text.html('<b class="reward-donate-sum">' + val + '</b>').append($editButton);
            $this.parents('#continue').find('.pay-i span').text(val);
        } else {
            $text.html(nl2br(val)).append($editButton);
        }

        $thisWrapper.find('.origin-value').val(val);
        $thisWrapper.find('.edit-field').hide();
        $thisWrapper.find('.text-field').show();

        if($thisWrapper.hasClass('js-synopsis')){

            editSynopsisHeight = $('.js-synopsis .text-field').height();

            // console.log(editSynopsisHeight);

            if(editSynopsisHeight > 132){
                // $('.js-synopsis').removeClass('auto-height');
                $('.read-more-synopsis').removeClass('hidden');
            } else {
                $('.read-more-synopsis').addClass('hidden');
            }
        }

    });

    $('.publish-project').on('click', function () {
        $.ajax({
            url: window.Config.BASE_PATH + '/api/v1/project/publish-project',
            data: {'pid': $('#pid').val()},
            type: 'post',
            dataType: 'json',
            success: function (resp) {
                if (resp.success) {
                    System.notify('Your project has been successfully published. Congratulations!');
                } else {
                    System.showErrors(resp.message);
                }
            }
        })
        $(this).parent().remove();
    });

    $(document).on('click', '.edit', function () {
        var $el = $(this).closest('.edit-block');
//        if (el.parents('#continue')) {
//            $(el).find('.edit-field').show().find('.edited-field').removeClass('success');
//            console.log('continue');
//        } else {
        $el.find('.edit-field').show().find('.edited-field').removeClass('success');
        // $("html, body").animate({scrollTop: $(el).offset().top - 150}, "slow");
        // }
        $el.find('.text-field').hide();
        if($el.hasClass('js-synopsis')){
            $('.js-synopsis').addClass('auto-height');
            $('.read-more-synopsis').addClass('hidden');
        }
        // $(el).find('input, select, textarea').focus();

    });

    // Upload Media Files in .ZIP on Project Page
    var optionsMedia = {
        beforeSubmit: beforeMediaSubmit, // pre-submit callback
        success: afterMediaSuccess, // post-submit callback
        uploadProgress: OnProgressMedia, //upload progress callback
        resetForm: true        // reset the form after successful submit
    };
    $('.upload-attach-btn').change(function (e) {
        e.preventDefault();
        this.form.action = window.Config.BASE_PATH + '/api/v1/project/upload-attach';
        $(this.form).ajaxSubmit(optionsMedia);
        return false;
    });

    function afterMediaSuccess(resp) {
        $('#progressbox').hide();
        if (resp.success) {
            $('#attachUploaded').html(resp.data.fileName);
        } else {
            System.showErrors(resp.message);
        }
    }

    function beforeMediaSubmit() {

        if (window.File && window.FileReader && window.FileList && window.Blob) {
            //check empty input filed
            if (!$('#mediaFiles').val()) {
                System.error("No file selected");
                return false
            }
            var fsize = $('#mediaFiles')[0].files[0].size; //get file size
            var ftype = $('#mediaFiles')[0].files[0].type; // get file type
            switch (ftype) {
                case 'application/x-zip-compressed':
                case 'zip':
                    break;
                default:
                    System.error(locale['TEXT_IMG_WRONG_FORMAT']);
                    return false
            }

            // if File size > 300 MB - show proper error
            if (fsize > 304857600) {
                System.error("File must be 300 Mb or less.");
                return false;
            }

            // $('body').addClass('loading');
        } else {
            $("#output").html(locale['TEXT_PLEASE_UPGRADE_YOUR_BROWSER']);
            return false;
        }
    }

    function OnProgressMedia(event, position, total, percentComplete) {
        $('#progressbox').show();
        $('#progressbar').width(percentComplete + '%') //update progressbar percent complete
        $('#statustxt').html(percentComplete + '%'); //update status text
        if (percentComplete > 50) {
            $('#statustxt').css('color', '#000'); //change status text to white after 50%
        }
    }

/////////////////////////////////////////////////////////////////////////////////////////////

    var optionsCover = {
        beforeSubmit: beforeSubmitCover, // pre-submit callback
        success: afterSuccessCover, // post-submit callback
        uploadProgress: OnProgressCover, //upload progress callback
        resetForm: true        // reset the form after successful submit
    };
    //  Upload Cover
    // $('.load-image-btn').change(function () {
    //     readURL(this);
    // });
    //

    $('.load-image-btn').change(function (e) {
        e.preventDefault();
        this.form.action = window.Config.BASE_PATH + '/api/v1/project/upload-image';
        $(this.form).ajaxSubmit(optionsCover);
        return false;
    });

    function afterSuccessCover(resp) {
        $('body').removeClass('loading');
        if (resp.success) {
            var imgSrc = resp.data.fileName + '?' + Math.random(9999999);
            if (resp.data.type == 'cover') {
                $('.poster-block .cover-image').attr('src', imgSrc);
                $('.cnb-book-cover__image').attr('src', imgSrc);
                $('.cnb-book-cover__image-background').css({ 'background-image': 'url(' + imgSrc + ')' });
                $('.project-bg .pr-bg').attr('src', imgSrc);
                $('.project-bg .pr-bg').addClass('blur');
                $('.poster-block .delete').removeClass('inactive').show();
            }
        } else {
            System.showErrors(resp.message);
        }
    }

    function beforeSubmitCover() {
        if (window.File && window.FileReader && window.FileList && window.Blob) {
            if (!$('#CoverInput').val()) {
                System.error("No file selected");
                return false
            }
            var fsize = $('#CoverInput')[0].files[0].size; //get file size
            var ftype = $('#CoverInput')[0].files[0].type; // get file type
            switch (ftype) {
                case 'image/png':
                case 'image/jpeg':
                    break;
                default:
                    System.error(locale['TEXT_IMG_WRONG_FORMAT']);
                    return false
            }
            if (fsize > 5242880) {
                System.error("File must be 5 Mb or less.");
                return false;
            }
            $('body').addClass('loading');
        } else {
            $("#output").html(locale['TEXT_PLEASE_UPGRADE_YOUR_BROWSER']);
            return false;
        }
    }

    function OnProgressCover(event, position, total, percentComplete) {
    }

    $('.delete-cover-btn').on('click', function (e) {
        e.preventDefault();
        if ($('.poster-block .delete').hasClass('inactive')) {
            return;
        }
        $.ajax({
            url: window.Config.BASE_PATH + '/api/v1/project/delete-image',
            data: {'pid': $('#pid').val(), 'type': 'cover'},
            type: 'post',
            dataType: 'json',
            success: function (resp) {
                if (resp.success) {
                    $('.poster-block .cover-image').attr('src', resp.data.thumbName);
                    $('.project-bg .pr-bg').attr('src', '/new_img/b2b/back_cover_default.jpg');
                    $('.project-bg .pr-bg').removeClass('blur');
                    $('.poster-block .delete').addClass('inactive').hide();
                    System.notify('Saved!');
                } else {
                    System.showErrors(resp.message);
                }
            }
        });
    })

//////////////////////////////////////////////////////////////////////////////////////

    // Upload Gallery Files for Updates
    var optionsGallery = {
        beforeSubmit: beforeGallerySubmit, // pre-submit callback
        success: afterGallerySuccess, // post-submit callback
        uploadProgress: OnProgressGallery, //upload progress callback
        resetForm: true        // reset the form after successful submit
    };
    $('.upload-gallery-btn').change(function (e) {
        e.preventDefault();
        this.form.action = window.Config.BASE_PATH + '/api/v1/project/upload-gallery';
        $(this.form).ajaxSubmit(optionsGallery);
        return false;
    });

    function afterGallerySuccess(resp) {
        $('body').removeClass('loading');
        if (resp.success) {
            $('.gallery-list').append('<li style="width: 9%; margin: 0"><img src="' + resp.data.thumbName + '" style="width: 100%"></li>');
        } else {
            System.showErrors(resp.message);
        }
    }

    function beforeGallerySubmit() {

        if (window.File && window.FileReader && window.FileList && window.Blob) {
            //check empty input filed
            if (!$('#imgGallery').val()) {
                System.error("No file selected");
                return false
            }
            var fsize = $('#imgGallery')[0].files[0].size; //get file size
            var ftype = $('#imgGallery')[0].files[0].type; // get file type
            //allow file types
            switch (ftype) {
                case 'image/png':
                //case 'image/gif':
                case 'image/jpeg':
                    //case 'image/pjpeg':
                    break;
                default:
                    System.error(locale['TEXT_IMG_WRONG_FORMAT']);
                    return false
            }

            // if File size > 5 MB - show proper error
            if (fsize > 5242880) {
                System.error("File must be 5 Mb or less.");
                return false;
            }


            $('body').addClass('loading');
        } else {
            $("#output").html(locale['TEXT_PLEASE_UPGRADE_YOUR_BROWSER']);
            return false;
        }
    }

    function OnProgressGallery(event, position, total, percentComplete) {
        $('#progressbox').show();
        $('#progressbar').width(percentComplete + '%') //update progressbar percent complete
        $('#statustxt').html(percentComplete + '%'); //update status text
        if (percentComplete > 50) {
            $('#statustxt').css('color', '#000'); //change status text to white after 50%
        }
    }

    $('.edited-field').each(function (index) {
        if ($(this).val() == '') {
            if ($(this).attr('id') == 'description') {
                var wohtml = $('#description-origin-value').val();
                if (wohtml.length == 0) {
                    $(this).closest('.edit-block').find('.edit').click();
                }
            } else {
                $(this).closest('.edit-block').find('.edit').click();
            }
        }
    });

    /**************************************************************************************/



    /*******************************Rewards*******************************************************/

//    $('.set-reward-form').submit(function (e) {
    $('.continue').on('click', function (e) {
        e.preventDefault();

        // var l = Ladda.create($('button[type=submit]', this).get(0));
        // l.start();
        //
//        var form = this;
        var form = $(this).parents('.set-reward-form');

        if ($(this).find('button').hasClass('disable')) {
            return false;
        } else {
//            $(form).ajaxSubmit({
//                beforeSubmit: function (arr, $form, options) {
            // add validation
            if (errorsArr.length > 0) {
                System.error(errorsArr[0]);
                return false;
            } else {
                return true;
            }
//                },
//                success: function (response, $form, options) {
//                    // l.stop();
//                    show_alert(response.message);
//                },
//                error: function (response, $form, options) {
//                    // l.stop();
//                }
//            });
        }
        return false;
    });

    // initialize tooltipster on text input elements
    $('.add-reward-form .form-control, \n\
    .set-reward-form input, \n\
    .book-info-form .cb-form-control, \n\
    .about-author-form .cb-form-control').tooltipster({
        trigger: 'custom',
        onlyOne: false,
        position: 'top-right',
        offsetX: 13
    });

    // initialize validate plugin on the form
    $('.add-reward-form').validate({
        errorPlacement: function (error, element) {
            $(element).tooltipster('update', $(error).text());
            $(element).tooltipster('show');
            errorsArr = [];
            errorsArr.push($(error).text());
        },
        success: function (label, element) {
            $(element).tooltipster('hide');
        },
        rules: {
            pledge: {
                required: true
            },
            title: {
                required: true,
                minlength: 3,
                maxlength: 100
            },
            description: {
                required: true,
                minlength: 6,
                maxlength: 1000
            },
            includes: {
                required: false,
                minlength: 6,
                maxlength: 1000
            },
            limitRewards: {
                required: false
            }
        },
        messages: {
            pledge: {
                required: "Please specify the amount of the pledge."
            },
            title: {
                required: "Sorry, the title cannot be empty.",
                title: "Sorry, the title is too short (3 characters min and 100 characters max)"
            },
            description: {
                required: "Sorry, the description cannot be empty.",
                message: "Sorry, the description is too short (6 characters min and 1000 characters max)"
            },
            includes: {
                required: "Sorry, the “includes” section cannot be empty.",
                message: "Sorry, the “includes” is too short (6 characters min and 1000 characters max)"
            }
        },
        submitHandler: function (form) {
            return false;
        }
    });

    $('.set-reward-form').validate({
        errorPlacement: function (error, element) {
            $(element).tooltipster('update', $(error).text());
            $(element).tooltipster('show');
            errorsArr = [];
            errorsArr.push($(error).text());
        },
        success: function (label, element) {
            $(element).tooltipster('hide');
        },
        rules: {
            pledge: {
                required: true
            }
        },
        messages: {
            pledge: {
                required: "Please specify the amount of the pledge."
            }
        },
        submitHandler: function (form) {
            return false;
        }
    });

    $('.book-info-form').validate({
        errorPlacement: function (error, element) {
            $(element).tooltipster('update', $(error).text());
            $(element).tooltipster('show');
            errorsArr = [];
            errorsArr.push($(error).text());
        },
        success: function (label, element) {
            $(element).tooltipster('hide');
        },
        rules: {
            bookTitle: {
                required: true,
                minlength: 3,
                maxlength: 100
            },
            authorName: {
                required: true,
                minlength: 3,
                maxlength: 100
            },
            shortDescription: {
                required: true,
                minlength: 6,
                maxlength: 600
            }
        },
        messages: {
            bookTitle: {
                required: "Sorry, the field cannot be empty.",
                bookTitle: "Sorry, the title is too short (3 characters min and 100 characters max)"
            },
            authorName: {
                required: "Sorry, the field cannot be empty.",
                authorName: "Sorry, the name is too short (3 characters min and 100 characters max)"
            },
            shortDescription: {
                required: "Sorry, the field cannot be empty.",
                shortDescription: "Sorry, the description is too short (6 characters min and 600 characters max)"
            }
        },
        submitHandler: function (form) {
            return false;
        }
    });

    $('.about-author-form').validate({
        errorPlacement: function (error, element) {
            $(element).tooltipster('update', $(error).text());
            $(element).tooltipster('show');
            errorsArr = [];
            errorsArr.push($(error).text());
        },
        success: function (label, element) {
            $(element).tooltipster('hide');
        },
        rules: {
            aboutAuthor: {
                required: true,
                minlength: 6,
                maxlength: 10000
            }
        },
        messages: {
            aboutAuthor: {
                required: "Sorry, the field cannot be empty.",
                shortDescription: "Sorry, the text should contain from 6 to 10000 characters."
            }
        },
        submitHandler: function (form) {
            return false;
        }
    });

    $('.more-det').on('click', function () {
        $(this).prev().slideToggle('slow');
    });


    //remove reward
    $(document).on('click', '.remove-reward', function () {
        var id = $(this).data('id');
        var pid = $('#pid').val();
        if (confirm('You are sure?')) {
            $.ajax({
                url: window.Config.BASE_PATH + '/api/v1/rewards/del-reward',
                data: {'id': id, 'pid': pid},
                type: 'post',
                dataType: 'json',
                success: function (resp) {
                    if (resp.success) {
                        $('.rewards-block').html(resp.data.html);
                        System.notify('Reward deleted.');
                    } else {
                        System.showErrors(resp.message);
                    }
                }
            });
            // $(this).parents('.reward-block').remove();
        }
    });

    //edit reward
    $(document).on('click', '.cancel-edit-reward', function (e) {
        e.preventDefault();
        var el = $(this.closest('.reward-block'));
        $(el).find('.reward-form').remove();
        $(el).find('.reward').show();
        return false;
    });


    $(document).on('click', '.edit-reward', function () {
        var id = $(this).data('id');
        var pid = $('#pid').val();
        var me = $(this);
        $.ajax({
            url: window.Config.BASE_PATH + '/api/v1/rewards/get-reward-form',
            data: {'id': id, 'pid': pid},
            type: 'post',
            dataType: 'json',
            success: function (resp) {
                if (resp.success) {
                    me.closest('.reward').hide();
                    me.closest('.reward-block').prepend(resp.data.form);
                    $('.update-reward-form .form-control').each(function () {
                        var val = $(this).val();
                        if (val.length > 0) {
                            $(this).parent().find('label').addClass('not-empty');
                        }
                    });
                    labelFix();
                    initUpdateRewardForm();
                } else {
                    System.showErrors(resp.message);
                }
            }
        });
    });

    //choosing reward
    $(document).on('click', '.choose-reward', function () {
        var id = $(this).data('id');
        var pid = $('#pid').val();
        var me = $(this);
        $.ajax({
            url: window.Config.BASE_PATH + '/api/v1/rewards/add-predef-reward',
            data: {'id': id, 'pid': pid},
            type: 'post',
            dataType: 'json',
            success: function (resp) {
                if (resp.success) {
                    $('.rewards-block').html(resp.data.html);
                    // me.parents('.reward').prepend('<button class="remove-reward" data-id="'+resp.data.id+'" type="button"><svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg></button>');
                    // // $('.choosen-rewards').prepend(me.parent().parent().parent());
                    // me.parents('.reward').next().html('Author reward');
                    // me.parent().parent().parent().removeClass('for-add').addClass('choosen-reward').appendTo('.choosen-rewards');
                    // me.remove();
                    System.notify('Saved!');
                } else {
                    System.showErrors(resp.message);
                }
            }
        });
    });

    $('.add-reward-form .add-new-rew').on('click', function (e) {
        e.preventDefault();

        var form = $(this).parents('.add-reward-form');
        var l = Ladda.create($('button[type=submit]', form).get(0));
        var pledge = form[0].pledge.value;
        var title = form[0].title.value;
        var description = form[0].description.value;

        l.start();

        $(form).ajaxSubmit({
            beforeSubmit: function (arr, $form, options) {
                // add validation
                if (!title || !description || !pledge) {
                    System.error(locale['TEXT_PLEASE_COMPLETE_ALL_THE_REQUIRED_FIELDS_CORRECTLY']);
                    l.stop();
                    if(!pledge){
                        form.find('[name="pledge"]').addClass('error');
                    }
                    if(!title){
                        form.find('[name="title"]').addClass('error');
                    }
                    if(!description){
                        form.find('[name="description"]').addClass('error');
                    }
                    return false;
                } else {
                    if (errorsArr[0].length > 0) {
                        System.error(errorsArr[0]);
                        l.stop();
                        return false;
                    } else {
                        return true;
                    }
                }
            },
            success: function (response, $form, options) {
                l.stop();
                show_alert(response.message, response.status);
                if (response.success) {
                    // $(form).parents('.reward-block').after(response.data.html);
                    $('.rewards-block').html(response.data.html);
                    // $('.choosen-rewards').prepend(response.data.reward);
                    $(form).trigger("reset");
                    $(form).find('.form-control').removeClass('success');
                }
            },
            error: function (response, $form, options) {
                l.stop();
            },
//            resetForm: true
        });
        return false;
    });

    initUpdateRewardForm();

    //continue popup show
    $('.continue').on('click', function (e) {
        e.preventDefault();
        var val = $('.continue-input').val();
        if ($('.continue-input').hasClass('error')) {
            return false;
        }
        $('#continue .edited-field').val(val);
        $('#continue .text-field .reward-donate-sum').html(val);
        $('#continue .edit-field').hide();
        $('#continue .text-field').show();
        $('#continue .pay-i span').html(val);
    });
    //choose-reward-popup show
    $(document).on('click', '.to-choose', function () {
        var revardId = $(this).find('button').data('id');

        var sum = $(this).parents('.reward').find('.pledge-sum b').html();
        var title = $(this).parents('.reward').find('.award-title').html();
        var info = $(this).parents('.reward').find('.award-descr').html();
        $('#choose-reward-popup #rewardId').val(revardId);
        $('#choose-reward-popup .pay-i span, #choose-reward-popup .pledge-sum b').html(sum);
        $('#choose-reward-popup .award-title').html(title);
        $('#choose-reward-popup .award-descr').html(info);
    });

    // summernote editor - download image
    function sendFile(file, url, editor) {
        $('body').addClass('loading');
        var data = new FormData();
        data.append("pid", $('#pid').val());
        data.append("FileInput", file);
        data.append("type", 'description');
        $.ajax({
            data: data,
            type: "POST",
            url: url,
            cache: false,
            contentType: false,
            processData: false,
            success: function (response) {
                if (response.success) {
                    editor.summernote('insertImage', response.data.fileName, function ($image) {
                        $image[0].alt = response.data.alt;
                    });
                    System.notify(response.message);
                } else {
                    System.showErrors(response.message);
                }
                $('body').removeClass('loading');

            },
            error: function (jqXHR, textStatus, errorThrown) {
                $('body').removeClass('loading');
            }
        });
    }

    $('.project-summernote').summernote({
        placeholder: $('#description-placeholder').val(),
        height: 500, //set editable area's height
        focus: false, //set focus editable area after Initialize summernote
        toolbar: [
            ['style', ['style']],
            ['font', ['bold', 'italic', 'underline', 'clear']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['insert', ['picture', 'video']],
        ],
        popover: {
            image: [
                ['remove', ['removeMedia']]
            ]
        },
        styleTags: ['p', 'h3'],
        fontNames: [
            'Open Sans',
            'Quattrocento',
            'sans-serif'
        ],
        disableDragAndDrop: true,
        fontNamesIgnoreCheck: [
            'Quattrocento'
        ],
        callbacks: {
            oninit: function () {
            },
            onChange: function (contents, $editable) {

                // var newcontents = contents.replace('width="640" height="360"', 'width="100%" height="420"');
                // if(newcontents != contents) {
                //     $('.summernote').summernote('code', newcontents);
                // }

                var id = $(this).parents('.summernote-box').attr('data-id');

                // contents = word_filter(contents);
                // console.log(contents);
                // $('#' + id).val(contents);

                $(this).parents('.tab-pane').find('.save-changes').prop('disabled', false);
                var wohtml = $("<div />").html($('.project-summernote').summernote('code')).text();
                if (wohtml.length < 300) {
                    $('.note-editor').removeClass('success').addClass('error');
                    addTooltipler($('.note-editor'), 'Please enter at least 300 characters');
                } else if (wohtml.length > 100000) {
                    $('.note-editor').removeClass('success').addClass('error');
                    addTooltipler($('.note-editor'), 'Please enter no more than 100000 characters');
                } else {
                    $('.note-editor').removeClass('error');
                    destroyTooltipler($('.note-editor'));
                }
            },
            onImageUpload: function (files) {
                var url = $(this).data('upload'); //path is defined as data attribute for  textarea
                sendFile(files[0], url, $(this));
            },
        }
    });

    $('.type-popup').on('click', function () {
        var id = $(this).data('id');
        $('#type .text-block').show();
        // $('#type .'+id).show();
        $('.js-more-link').hide();
        $('#type').show();
    });

    // if(pay == undefined) {
    //     var pay = 0;
    // }

// //    progress percent calc
//     if (pay < goal1 ||
//             pay === goal1) {
//         var per = (pay * 100) / goal1;
//         $('.progress-block .cine-book-light .progress-percent span').text(per);
//         $('.progress-block .cine-book-light .progress-bar').attr('aria-valuenow', per).css('width', per + '%');
//     } else if (pay > goal1 && !goal2) {
//         var per = (pay * 100) / goal1;
//         $('.progress-block .cine-book-light .progress-percent span').text(per);
//         $('.progress-block .cine-book-light .progress-bar').attr('aria-valuenow', '100').css('width', '100%');
//     } else if ((pay > goal1 && goal2 && !goal3) || (pay < parseInt(goal1 + goal2))) {
//         $('.progress-block .cine-book-light .progress-percent span').text('100');
//         $('.progress-block .cine-book-light .progress-bar').attr('aria-valuenow', '100').css('width', '100%');
//         var per = ((pay - goal1) * 100) / goal2;
//         $('.progress-block .cine-book-format .progress-percent span').text(per);
//         $('.progress-block .cine-book-format .progress-bar').attr('aria-valuenow', per).css('width', per + '%');
//     } else if (pay > parseInt(goal1 + goal2) && goal3) {
//         $('.progress-block .cine-book-light .progress-percent span,\n\
//             .progress-block .cine-book-format .progress-percent span').text('100');
//         $('.progress-block .cine-book-light .progress-bar,\n\
//             .progress-block .cine-book-format .progress-bar').attr('aria-valuenow', '100').css('width', '100%');
//         var per = (parseInt(pay - goal1 - goal2) * 100) / goal3;
//         $('.progress-block .movie-adapd .progress-percent span').text(per);
//         $('.progress-block .movie-adapd .progress-bar').attr('aria-valuenow', per).css('width', per + '%');
//     }
//
    /*vote block*/
    $('.vote-btn:not(.disabled)').on('click', function (e) {
        Auth.hasIdentity(function (status, resp) {
            if (status === false) {
                e.preventDefault();
                $('.login-facebook').attr('data-isvote', 1);
                $('.login-google').attr('data-isvote', 1);
                $('.js-join-b2c').attr('data-isvote', 1);
                $('.js-login-b2c').attr('data-isvote', 1);
                initiateRegistration('b2c');
                Auth.showLoginForm(null, null, null, $('#join-window'));
                return false;
            } else {
                var voteUtmSource = $('#vote-utm-source').val();
                var voteProjectUrl = $('#vote-project-url').val();
                $.ajax({
                    url: "/api/v1/vote/project",
                    type: 'POST',
                    dataType: "json",
                    data: {
                        projectId: projectId,
                        source: voteUtmSource
                    },
                    success: function (data) {
                        var votes = data.data.countVotes;
                        if(data.data.already) {
                            $('.vote-quantity span').text(votes);
                            $('.vote').hide();
                            $('.voting').append("<p class='already-vote'>You've already voted</p>");
                        }
                        if (data.status == 'success') {
                            if (typeof window['ga'] == 'function') {
                                ga('send', 'event', 'vote', voteProjectUrl, voteUtmSource);
                            }
                        }
                        show_alert(data.message, data.status);
                    }
                });
            }
        });
    });

    // function check_vote() {
    //     var vote = window.localStorage.getItem('vote_click');
    //     if (vote === '1') {
    //         $('.vote-btn').trigger( "click" );
    //         window.localStorage.removeItem('vote_click');
    //     }
    // }
    // check_vote();
    /*end vote block*/

//    submit donate form
    $('.pay-btn').on('click', function (e) {
        e.preventDefault;

        var form = $(this).parents('form');
        var l = Ladda.create($(this, form).get(0));
        var type = $(this).data('type');
        var sum = $(this).parents('.pay-info').find('.reward-donate-sum').text();
        var sumCents = sum * 100;

        $(this).parents('form').find('input[name="type"]').val(type);
        $(this).parents('form').find('input[name="amount"]').val(sumCents);

        $(this).parents('form').submit();
        l.start();
    });

    $('.pay-info .yc-return').on('click', function () {
        $('.donate-form')[0].reset();
    });
    
    $(document).on('click', '.c-close, .yc-return, .cancel-button, .cancel-crop', function () {
        $('.c-popup').fadeOut();
        if ($(this).closest('.c-popup').hasClass('cropping')) {
            $('#FileInput').val('');
            cropper.destroy();
        }
    });
    //breadcrumbs width
    if ($( window ).width() < 992){
        var breadcrumbsWidth = $('.breadcrumbs-project').width();
        var breadcrumbsAuthorWidth = $('.breadcrumbs-wrap>div').eq(2).width();
        var firstLastBreadcrumbsWidth = $('.last-breadcrumb').width();
        
        var lastBreadcrumbsWidth = breadcrumbsWidth - 122 - breadcrumbsAuthorWidth;
        
        if(firstLastBreadcrumbsWidth >= lastBreadcrumbsWidth){
            $('.breadcrumbs-wrap').addClass('breadcrumbs-wrap-after');
            $('.last-breadcrumb').width(lastBreadcrumbsWidth);            
        } else {
            $('.last-breadcrumb').width(firstLastBreadcrumbsWidth);
        }        
    }   
    
    //story short description toggle
    
    var shortDescriptionHeight = $('.short-description .text-field').height();
    var synopsisHeight = $('.js-synopsis .text-field').height();

    console.log(synopsisHeight);
    
    if (shortDescriptionHeight > 66) {
        $('.read-more-description').removeClass('hidden');
    }

    if (synopsisHeight > 132) {
        $('.read-more-synopsis').removeClass('hidden');
    }
    
    $(document).on('click', '.read-more-description, .read-more-authors-bio, .read-more-synopsis', function(){
        $(this).prev().toggleClass('auto-height');
        var text = $(this).text();
        $(this).text(
            text == "READ MORE" ? "READ LESS" : "READ MORE");
    });
    
    var authorsBioHeight = $('.about-author__info .text-field').height();
    
    if(authorsBioHeight > 68){
        $('.about-author__info .text-field').height(68);
        $('.read-more-authors-bio').show();
    }
    
});

function initUpdateRewardForm() {
    // initialize tooltipster on text input elements
    $('.update-reward-form .form-control').tooltipster({
        trigger: 'custom',
        onlyOne: false,
        position: 'top-right',
        offsetX: 13
    });

    $('.update-reward-form').validate({
        errorPlacement: function (error, element) {
            $(element).tooltipster('update', $(error).text());
            $(element).tooltipster('show');
            errorsArr = [];
            errorsArr.push($(error).text());
        },
        success: function (label, element) {
            $(element).tooltipster('hide');
        },
        rules: {
            pledge: {
                required: true
            },
            title: {
                required: true,
                minlength: 3,
                maxlength: 100
            },
            description: {
                required: true,
                minlength: 6,
                maxlength: 1000
            },
            includes: {
                required: false,
                minlength: 6,
                maxlength: 1000
            },
            limitRewards: {
                required: false
            }
        },
        messages: {
            pledge: {
                required: "Please specify the amount of the pledge."
            },
            title: {
                required: "Sorry, the title cannot be empty.",
                title: "Sorry, the title is too short (3 characters min and 100 characters max)"
            },
            description: {
                required: "Sorry, the description cannot be empty.",
                message: "Sorry, the description is too short (6 characters min and 1000 characters max)"
            },
            includes: {
                required: "Sorry, the “includes” section cannot be empty.",
                message: "Sorry, the “includes” is too short (6 characters min and 1000 characters max)"
            }
        }
    });

    $('.update-reward-form .add-new-rew').on('click', function (e) {
        e.preventDefault();

        var form = $(this).parents('.update-reward-form');
        var l = Ladda.create($('button[type=submit]', form).get(0));
        var title = form[0].title.value;
        var description = form[0].description.value;

        l.start();

        $(form).ajaxSubmit({
            beforeSubmit: function (arr, $form, options) {
                // add validation
                if (!title && !description) {
                    System.error(locale['TEXT_PLEASE_COMPLETE_ALL_THE_REQUIRED_FIELDS_CORRECTLY']);
                    l.stop();
                    return false;
                } else {
                    if (errorsArr.length > 0 && errorsArr[0].length > 0) {
                        System.error(errorsArr[0]);
                        l.stop();
                        return false;
                    } else {
                        return true;
                    }
                }
            },
            success: function (response, $form, options) {
                l.stop();
                show_alert(response.message, response.status);
                if (response.success) {
                    $(form).closest('.reward-block').replaceWith(response.data.form);
                }
            },
            error: function (response, $form, options) {
                l.stop();
            },
        });
        return false;
    });
}



function word_filter(content) {
    // Word comments like conditional comments etc
    content = content.replace(/<!--[\s\S]+?-->/gi, '');

    $('.for-change').html(content);
    $('.for-change *').removeAttr('style');
    $('.for-change *').removeAttr('id');

    content = $('.for-change *').html();

    return content;
    // Remove comments, scripts (e.g., msoShowComment), XML tag, VML content,
    // MS Office namespaced tags, and a few other tags
    content = content.replace(/<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|img|meta|link|style|\w:\w+)(?=[\s\/>]))[^>]*>/gi, '');

    // Convert <s> into <strike> for line-though
    content = content.replace(/<(\/?)s>/gi, "<$1strike>");

    // Replace nbsp entites to char since it's easier to handle
    //content = content.replace(/ /gi, "\u00a0");
    content = content.replace(/ /gi, ' ');

    // Convert <span style="mso-spacerun:yes">___</span> to string of alternating
    // breaking/non-breaking spaces of same length
    content = content.replace(/<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi, function (str, spaces) {
        return (spaces.length > 0) ? spaces.replace(/./, " ").slice(Math.floor(spaces.length / 2)).split("").join("\u00a0") : '';
    });

    // Parse out list indent level for lists
    $('p', content).each(function () {
        var str = $(this).attr('style');
        var matches = /mso-list:\w+ \w+([0-9]+)/.exec(str);
        if (matches) {
            $(this).data('_listLevel', parseInt(matches[1], 10));
        }
    });

    // Parse Lists
    var last_level = 0;
    var pnt = null;
    $('p', content).each(function () {
        var cur_level = $(this).data('_listLevel');
        if (cur_level != undefined) {
            var txt = $(this).text();
            var list_tag = '<ul></ul>';
            if (/^\s*\w+\./.test(txt)) {
                var matches = /([0-9])\./.exec(txt);
                if (matches) {
                    var start = parseInt(matches[1], 10);
                    list_tag = start > 1 ? '<ol start="' + start + '"></ol>' : '<ol></ol>';
                } else {
                    list_tag = '<ol></ol>';
                }
            }

            if (cur_level > last_level) {
                if (last_level == 0) {
                    $(this).before(list_tag);
                    pnt = $(this).prev();
                } else {
                    pnt = $(list_tag).appendTo(pnt);
                }
            }
            if (cur_level < last_level) {
                for (var i = 0; i < last_level - cur_level; i++) {
                    pnt = pnt.parent();
                }
            }
            $('span:first', this).remove();
            pnt.append('<li>' + $(this).html() + '</li>')
            $(this).remove();
            last_level = cur_level;
        } else {
            last_level = 0;
        }
    })

    content = $('[style]', content).removeAttr('style');
    $('[align]', content).removeAttr('align');
    $('span', content).replaceWith(function () {
        return $(this).contents();
    });
    $('span:empty', content).remove();
    $("[class^='Mso']", content).removeAttr('class');
    $('p:empty', content).remove();
    return content;
}

//    submit form in promote popup
function submitFriendsEmailsValidation() {
    var form = $('#form-promote-email-users');
    var mail = $(form).find('input');
    var message = $(form).find('textarea');

    var valMail = $.trim(mail.val());
    var valMessage = $.trim(message.val());

    if (valMail.length === 0) {
        mail.addClass('error');
        addTooltipler(mail, locale['TEXT_EMAIL_CANNOT_BE_EMPTY']);
        System.error(locale['TEXT_EMAIL_CANNOT_BE_EMPTY']);
        return false;
    } else if (valMail.length > 0 && valMail.length < 3 || valMail.length > 100) {
        addTooltipler(mail, 'Sorry, the mail should contain from 3 to 100 characters');
        System.error('Sorry, the mail should contain from 3 to 100 characters');
        return false;
    } else {
        destroyTooltipler(mail);
    }

    if (valMessage.length === 0) {
        message.addClass('error');
        addTooltipler(message, locale['TEXT_MESSAGE_CANNOT_BE_EMPTY']);
        System.error(locale['TEXT_MESSAGE_CANNOT_BE_EMPTY']);
        return false;
    } else if (valMessage.length > 0 && valMessage.length < 6 || valMessage.length > 1000) {
        addTooltipler(message, 'Sorry, the message should contain from 3 to 1000 characters');
        System.error('Sorry, the message should contain from 6 to 1000 characters');
        return false;
    } else {
        destroyTooltipler(message);
    }

    if (valMail.length < 3 || valMessage < 6 || valMail.length > 100 || valMessage.length > 1000) {
        return false;
    }
    return true;
}
;

